import { Component } from '@angular/core';

@Component({
    selector: 'app-report',
    templateUrl: './report.component.html',
    styleUrl: './report.component.scss',
    standalone: false
})
export class ReportComponent {

}
